import { animate, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { fadeScaleIfAmount } from '../../../animations/fade-scale.if.animation';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { TooltipDirective } from '../../../shared/directives/tooltip.directive';

@Component({
  selector: 'app-add-section',
  templateUrl: './add-section.component.html',
  styleUrls: ['./add-section.component.scss'],
  animations: [
    trigger('button', fadeScaleIfAmount(0.8)),
    trigger('buttonIcon', [
      transition(':enter', [
        style({ transform: 'scale(1.25)' }),
        animate('0.15s ease-out', style({ transform: 'scale(1)' })),
      ]),
      transition(':leave', [
        style({ transform: 'scale(1)' }),
        animate('0.15s ease-out', style({ transform: 'scale(1.25)' })),
      ]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonDirective, SvgComponent, TooltipDirective],
})
export class AddSectionComponent {
  @Input() gallery: GalleryDto;
  @Input() darkBackgroundColor: boolean;
  @Input() backgroundColor: string;
  @Input() testId: string;
  @Input() visible: boolean;
  @Output() onOpen: EventEmitter<void> = new EventEmitter();

  async open() {
    this.onOpen.emit();
  }
}
